export default{
  "Mute Video": "Mute Video",
  "HitPaw Online Mute Video": "Mute Video Online HitPaw",
  "Fast and easy to remove sound from your video online": "Cepat dan mudah untuk menghapus suara dari video Anda secara online",
  "Muting": "Mute",
  "Mute Failed": "Mute Gagal",
  "Mute New": "Mute Baru"
};